import React from 'react';

import { useForm } from 'react-hook-form';
import { LbInput, YesNoBtnRow } from '@infoods/lifebase-ui';

import { UploadFiles } from '../../../shared/components/form-components';
import classes from './NgzSendViaChatForm.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { closeNgModal } from '../../../shared/utils/angularUtils';
import { useSendViaChatForm } from './NgzSendViaChatForm.hook';

type NgzSendViaChatFormProps = {
  userIdList: number[];
  openSendingMessageModal: () => void;
};

export type FormValues = {
  message: string;
};

const NgzSendViaChatForm = ({
  userIdList,
  openSendingMessageModal,
}: NgzSendViaChatFormProps) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<FormValues>({ mode: 'onBlur' });

  const { files, setFiles, onSubmit } = useSendViaChatForm(
    userIdList,
    openSendingMessageModal,
  );

  return (
    <form>
      <LbInput
        label="Your message"
        name="message"
        control={control}
        variant="standard"
        rules={{ required: 'Message is required' }}
      />
      <UploadFiles register={register} files={files} setFiles={setFiles} />
      <YesNoBtnRow
        className={classes.btnRow}
        noText="Cancel"
        noHandler={closeNgModal}
        yesText="Send"
        yesHandler={handleSubmit(onSubmit)}
        yesDisabled={!isValid}
      />
    </form>
  );
};

angularizeWithProviders(NgzSendViaChatForm, 'ngzSendViaChatForm', {
  userIdList: '<',
  openSendingMessageModal: '<',
});

export { NgzSendViaChatForm };
